export default {
    accountTagsViewEntities_vehicles: "Vehículos",
    accountTagsViewEntities_drivers: "Conductores",
    accountTagsViewEntities_landmarks: "Landmarks",
    accountTagsViewEntities_users: "Usuarios",
    accountTagsViewEntities_forms: "Forms",
    accountTagsViewEntities_geofences: "Geofences",
    accountTagsViewEntities_dynamicForms: "Formularios Dinámicos",
    accountTagsViewEntities_assets: "Activos"
};